import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { LegalPage, LegalSection } from "../../components/shared/LegalPage";

export default function CgvPage() {
  const [terms, setTerms] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/terms/current").then((r) => setTerms(r.data)).catch(() => setTerms(null)).finally(() => setLoaded(true));
  }, []);

  return (
    <LegalPage
      overline="Contrat"
      title="Conditions Générales"
      accent="de Vente"
      testId="legal-cgv-page"
    >
      {!loaded ? null : terms ? (
        <LegalSection title={`${terms.title} — version ${terms.version}`} testId="legal-cgv-content">
          <p className="text-xs uppercase tracking-[0.15em] text-muted-foreground" data-testid="legal-cgv-version">
            Version {terms.version} — applicable depuis le {terms.effective_at}
          </p>
          <div data-testid="legal-cgv-text">
            {terms.content.split("\n").map((line, i) => {
              const trimmed = line.trim();
              if (!trimmed) return null;
              if (/^Article\s+\d+\s+—/.test(trimmed)) {
                return (
                  <h3 key={i} className="mt-6 border-l-2 border-gold pl-3 font-heading text-base font-semibold text-deepgreen first:mt-2" data-testid={`cgv-article-${i}`}>
                    {trimmed}
                  </h3>
                );
              }
              if (trimmed.startsWith("— ")) {
                return (
                  <p key={i} className="flex gap-2 pl-4">
                    <span className="shrink-0 text-gold" aria-hidden>—</span>
                    <span>{trimmed.slice(2)}</span>
                  </p>
                );
              }
              return <p key={i}>{trimmed}</p>;
            })}
          </div>
        </LegalSection>
      ) : (
        <LegalSection title="Conditions Générales de Vente" testId="legal-cgv-content">
          <p>Les Conditions Générales de Vente sont en cours de publication. Pour toute question : contact@art-events.fr.</p>
        </LegalSection>
      )}
    </LegalPage>
  );
}
